const $doc = $(document);

/**
 * Add cart item(s)
 * @return {Void}
 */

$doc.on("change", ".js-product-quantity", function (event) {
  event.preventDefault();

  const $this = $(this);
  let currentInputVal = parseInt($this.val());

  $(".js-ajax-add").attr("data-qty", currentInputVal);
});

$doc.on("click", ".js-ajax-add", function (event) {
  event.preventDefault();

  const $this = $(this);
  const id = $this.closest("form").find('input[name="id"]').val();
  const quantity = parseInt($this.attr("data-qty"));
  const shippingTargetElement = $('.form__row .shipping__content [data-shipping-metaid]:not([hidden])');

  let shipping_availability =
  shippingTargetElement.find("#shipping_availability").length < 1
    ? shippingTargetElement[0].innerText
    : shippingTargetElement.find("#shipping_availability")[0].value;

    const items = [
    {
      id,
      quantity,
      properties: {
        availability: shipping_availability.trim(),
      },
    },
  ];

  $this.addClass("is-loading");

  Cart.add(items);
});

/**
 * Remove item
 * @return {Void}
 */

$doc.on("click", ".js-line-item-remove", function (event) {
  event.preventDefault();

  const $this = $(this);
  const id = $this.data("key");
  const isCartItem = $this.closest(".js-cart-item").length;
  let isCartPage = isCartItem ? true : false;

  Cart.updateItem(0, id, null, isCartPage);
});
